module["exports"] = [
  "آقای",
  "خانم",
  "دکتر"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fa/name/prefix.js
// module id = 607
// module chunks = 0